import {
  FilterLabelLookup,
  FilterLabelValue,
} from '@/catalog/utils/parse-indexed-filter-for-label';
import QuickFilterPill from './quick-filter-pill';
import removeSelectedFilter from '@/catalog/utils/remove-selected-filter';
import { IndexedFilters } from '@/catalog/types/filters';
import addSelectedFilter from '@/catalog/utils/add-selected-filter';
import hasSelectedFilter from '@/catalog/utils/has-selected-filter';
import Spacer from '@/common/components/spacer';

const QUICK_FILTERS: FilterLabelValue[] = [
  {
    label: 'Sedan',
    filter: {
      key: 'body_type',
      value: 'Sedan',
    },
  },
  {
    label: 'SUV',
    filter: {
      key: 'body_type',
      value: 'SUV',
    },
  },
  {
    label: 'Recently added',
    filter: {
      key: 'featured',
      value: 'Recently added',
    },
  },
];

interface QuickFilterPillsProps {
  selectedFilters: IndexedFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<IndexedFilters>>;
}

export default function QuickFilterPills({
  selectedFilters,
  setSelectedFilters,
}: QuickFilterPillsProps) {
  const onClick = (filter: FilterLabelLookup) =>
    setSelectedFilters(
      hasSelectedFilter(filter, selectedFilters)
        ? removeSelectedFilter(filter, selectedFilters)
        : addSelectedFilter(filter, selectedFilters)
    );

  return (
    <div className="relative min-w-0">
      <div className="scrollbar-hide flex snap-x snap-mandatory gap-[4px] overflow-x-auto">
        {/* Need this spacer to create initial gap so that the first pill isn't underneath the gradient on first load */}
        <Spacer variant="width16" />
        {QUICK_FILTERS.map(({ label, filter }, index) => (
          <QuickFilterPill
            key={`quick-filter-${index}-${label}`}
            name={label}
            active={hasSelectedFilter(filter, selectedFilters)}
            onClickDelegate={() => onClick(filter)}
          />
        ))}
      </div>
      <div className="pointer-events-none absolute left-0 top-0 h-full w-[16px] bg-[linear-gradient(90deg,#FFF_42.22%,rgba(255,_255,_255,_0.00)_95%)]" />
    </div>
  );
}
